import filter from '@/js/util/symbols/filter'

export default {
  inject: { filter },

  render(createElement) {
    return createElement('select', {
      on: {
        change: ({ target: { value } }) => {
          this.filter.$emit('set:checkbox', { type: value })
        },
      },
    }, this.$slots.default)
  },
}



// WEBPACK FOOTER //
// ./src/js/components/BaseFilterSelect.js